import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AgRendererComponent } from "ag-grid-angular";

@Component({
    template: `
  <input type="text" class="form-control form-control-sm"  (change)="onAmountChange($event)" [(ngModel)]="amount"/>          `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReserveAmountRendererComponent implements AgRendererComponent {
  params: any;
  amount:Number;
  agInit(params: any): void {
    this.params = params;
    this.amount = this.params.data.amount;
    //console.log('Ag Grid: ' + JSON.stringify(this.params.data, this.getCircularReplacer()));
  }

  onAmountChange(event){
    const amount = (event.target as HTMLInputElement).value;
    this.amount = amount as any;
    this.params.data.amount = amount;
    const rowIndex = this.params.node.rowIndex;
    let claimReserve = this.params.context.componentParent.claimReserves[rowIndex];
    if(claimReserve !== undefined){
      claimReserve.reserveAmount = this.amount;
    }
    else{
      this.params.context.componentParent.claimReserves[rowIndex] = {reserveAmount: this.amount};
    }
    //console.log('event: ' + JSON.stringify(this.params.context.componentParent.claimReserves,  this.getCircularReplacer())); 
  }

  refresh(params: any): boolean {
    return false;
  }

  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };
}
